const headerAnimated = {
	el: {
		header: document.querySelector('.header'),
		mainContent: document.querySelector('.wrapper'),
		btnToggleMenu: document.querySelector('.js-toggle-menu')
	},

	vars: {
		previousKnownScrollPosition: '',
		lastKnownScrollPosition: 0,
		ticking: false
	},

	fxAnimateOnScroll(lastScrollPosition, previousScrollPosition) {
		if (previousScrollPosition > lastScrollPosition && previousScrollPosition > 10)
			this.el.header.classList.add('header--fixed')

		else {
			this.el.header.classList.remove('header--fixed')
			this.el.header.classList.remove('open')
		}
	},

	fxToggleMenu() {
		this.el.btnToggleMenu.addEventListener('click', () => {
			this.el.header.classList.contains('open') ? this.el.header.classList.remove('open') : this.el.header.classList.add('open')
		})
	},

	fxThrottleScroll() {
		this.vars.previousKnownScrollPosition = this.vars.lastKnownScrollPosition
		this.vars.lastKnownScrollPosition = window.scrollY

		if (!this.vars.ticking) {
			window.requestAnimationFrame(() => {
				this.fxAnimateOnScroll(this.vars.lastKnownScrollPosition, this.vars.previousKnownScrollPosition)
				this.vars.ticking = false
			})

			this.vars.ticking = true
		}
	},

	events() {
		window.addEventListener('scroll', () => this.fxThrottleScroll())
	},

	init() {
		if (this.el.header) {
			this.events()
			this.fxToggleMenu()
		}
	}
}

headerAnimated.init()